import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const CollectionsTableRow = ({
    collection,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng.startsWith('ar');

    const titleEn = collection?.title?.en || collection?.title?.ar || '-';
    const titleAr = collection?.title?.ar || collection?.title?.en || '-';

    const typeLabel = collection?.type === 'automatic'
        ? (isArabic ? 'تلقائي' : 'Automatic')
        : (isArabic ? 'يدوي' : 'Manual');

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, collection.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align="start">{index + 1}</TableCell>

            {/* Title EN */}
            <TableCell align="start" sx={{ fontWeight: 500 }}>
                {titleEn}
            </TableCell>

            {/* Title AR */}
            <TableCell align="start" sx={{ fontWeight: 500 }}>
                {titleAr}
            </TableCell>

            {/* Type */}
            <TableCell align="start">
                <Chip
                    label={typeLabel}
                    size="small"
                    variant="outlined"
                    color={collection?.type === 'automatic' ? 'primary' : 'default'}
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* Slug */}
            <TableCell align="start">
                <Chip
                    label={collection?.slug}
                    size="small"
                    variant="outlined"
                    sx={{ borderRadius: '6px', fontWeight: 'bold', fontFamily: 'monospace' }}
                />
            </TableCell>

            {/* Status */}
            <TableCell align="center">
                <Chip
                    label={collection?.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    color={collection?.is_active ? 'success' : 'error'}
                    size="small"
                    sx={{ borderRadius: '6px', minWidth: '70px' }}
                />
            </TableCell>

            {/* Created At */}
            <TableCell align="start" sx={{ whiteSpace: 'nowrap' }}>
                {collection?.created_at ? dayjs(collection.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* Actions */}
            <TableCell align="right">
                <IconButton onClick={(event) => onMenuOpen(event, collection)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default CollectionsTableRow;
